<template>
  <div class="flex flex-col justify-center px-6 xl:px-12">
    <transition-group
      id="cardlist"
      tag="div"
      name="list"
      class="w-full grid grid-cols-1 lg:grid-cols-3 gap-12 group"
    >
      <div
        v-for="item in itemsDisplayed"
        :key="item.key"
        :style="{ height: '350px' }"
        class="relative cw-gradient p-2 rounded-3xl overflow-hidden"
      >
        <div
          :style="[
            { height: 'calc(100% - 1rem)' },
            { width: 'calc(100% - 1rem)' },
            {
              backgroundImage: item.imageUrl,
            },
            item.imagePosition
              ? { backgroundPosition: item.imagePosition }
              : {},
          ]"
          class="bg-center bg-no-repeat bg-cover z-10 rounded-3xl overflow-hidden absolute transition-all duration-300"
        >
          <div
            class="flex flex-col items-center justify-end w-full h-full black-bottom-overlay p-2"
          >
            <h4 class="hidden md:block text-cw-300 text-center mb-2">
              {{ item.subtitle }}
            </h4>
            <h5 class="md:hidden text-cw-300 text-center mb-2">
              {{ item.subtitle }}
            </h5>
            <h3 class="hidden md:block text-white text-center pb-2">
              {{ item.title }}
            </h3>
            <h4 class="md:hidden text-white text-center pb-2">
              {{ item.title }}
            </h4>
          </div>
        </div>
        <div
          :style="[
            { height: 'calc(100% - 1rem)' },
            { width: 'calc(100% - 1rem)' },
          ]"
          class="bg-cw-900 z-20 opacity-0 hover:opacity-100 rounded-3xl overflow-hidden absolute transition-all duration-300 px-3 py-4 md:p-6 flex flex-col items-center justify-center"
        >
          <h4 class="hidden md:block text-cw-300 text-center mb-2">
            {{ item.subtitle }}
          </h4>
          <h5 class="md:hidden text-cw-300 text-center mb-2">
            {{ item.subtitle }}
          </h5>
          <h3 class="hidden md:block text-white text-center pb-2">
            {{ item.title }}
          </h3>
          <h4 class="md:hidden text-white text-center pb-2">
            {{ item.title }}
          </h4>
          <p class="text-white text-center">
            {{ item.description }}
          </p>
        </div>
      </div>
    </transition-group>

    <div
      v-if="length < items.length"
      class="flex justify-center lg:col-span-3 w-full mt-20"
    >
      <button
        class="btn btn-black font-nunito shadow-lg mb-0"
        @click="loadMore"
      >
        See more
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,

      default: () => [
        {
          key: 'webinar',
          imageUrl: 'url(/img/cw-marketing/connections-connect-webinar.jpg)',
          subtitle: 'Host or participate',
          title: 'in a Webinar',
          description: `Host or participate in a webinar to engage with students online, discussing various career paths, industry trends, and personal experiences. Webinars provide flexibility and can reach a wide audience, making it easy for students to gain valuable information and ask questions.`,
        },
        {
          key: 'mentor',
          imageUrl: 'url(/img/cw-marketing/connections-connect-mentor.jpg)',
          subtitle: 'Become a',
          title: 'Mentor',
          description: `Mentor a student to help them develop their skills and interest in a specific industry. Receiving guidance from someone who is already in their desired role can be inspiring and provide valuable insights.`,
        },
        {
          key: 'presentation',
          imageUrl:
            'url(/img/cw-marketing/connections-connect-in-class-speaker.jpg)',
          subtitle: 'Do a class',
          title: 'Presentation',
          description: `Do a class Presentation Speak to students in their classroom to share your career journey, insights, and experiences. This firsthand knowledge can spark interest and provide students with a realistic perspective of what it's like to work in your industry.`,
        },
        {
          key: 'interview',
          imageUrl:
            'url(/img/cw-marketing/connections-connect-mock-interview.jpg)',
          subtitle: 'Conduct a',
          title: 'Mock Interview',
          description: `Conduct mock interviews with students to help them practice and
              refine their interview skills. This role-play exercise provides
              practical experience and constructive feedback, boosting students'
              confidence for real job interviews.`,
        },
        {
          key: 'shadowing',
          imageUrl:
            'url(/img/cw-marketing/connections-connect-work-shadowing.jpg)',
          imagePosition: 'right',
          subtitle: 'Offer',
          title: 'Work Shadowing',
          description: `Offer students the opportunity to shadow you at work, allowing
              them to observe your daily tasks and workplace environment. This
              immersive experience helps students understand the realities of a
              specific job and can clarify their career aspirations.`,
        },
        {
          key: 'expo',
          imageUrl:
            'url(/img/cw-marketing/connections-connect-career-expo.jpg)',
          subtitle: 'Join a career',
          title: 'Roadshow/Expo',
          description: `Participate in a career roadshow or expo to showcase your industry
              and interact with students. These events provide a platform for
              students to explore various career options, network with
              professionals, and gather information about potential career
              paths.`,
        },
        {
          key: 'project',
          imageUrl:
            'url(/img/cw-marketing/connections-connect-learning-task.jpg)',
          subtitle: 'Manage a',
          title: 'Project-Based Learning Task',
          description: `Collaborate with educators to design and implement a project-based
              learning task related to your industry. These hands-on projects
              encourage students to apply their knowledge, develop
              problem-solving skills, and gain practical experience in a
              real-world context.`,
        },
        {
          key: 'event_tertiary',
          imageUrl:
            'url(/img/cw-marketing/connections-connect-tertiary-training.jpg)',
          subtitle: 'Join a',
          title: 'Tertiary/Training Event',
          description: `Engage with students at tertiary or training events to discuss
              further education and training opportunities. Sharing insights
              about different programs and institutions can help students make
              informed decisions about their educational and career pathways.`,
        },
        {
          key: 'competition',
          imageUrl:
            'url(/img/cw-marketing/connections-connect-industry-competition.jpg)',
          subtitle: 'Run an',
          title: 'Industry Competition',
          description: `Organise or support industry competitions for students,
              challenging them to solve problems or create projects related to
              your field. Competitions foster creativity, critical thinking, and
              teamwork, while providing students with a taste of real-world
              challenges in your industry.`,
        },
        {
          key: 'event_industry',
          imageUrl:
            'url(/img/cw-marketing/connections-connect-industry-event.jpg)',
          subtitle: 'Run an',
          title: 'Industry Event',
          description: `Invite students to attend industry events such as conferences,
              seminars, or trade shows. These events expose students to current
              trends, innovations, and networking opportunities within their
              field of interest.`,
        },
        {
          key: 'media',
          imageUrl: 'url(/img/cw-marketing/connections-connect-video.jpg)',
          subtitle: 'Create',
          title: 'Video/Media Clips',
          description: `Create or share video and media clips that highlight your
              industry, career journey, and daily work life. These visual tools
              can captivate students' interest and provide a dynamic way to
              learn about various professions.`,
        },
        {
          key: 'displays',
          imageUrl:
            'url(/img/cw-marketing/connections-connect-career-display.jpg)',
          subtitle: 'Exhibit',
          title: 'Career Displays',
          description: `Set up career displays at schools or community centres to provide
              students with visual and interactive information about different
              career paths. These displays can include brochures, posters, and
              interactive elements to engage students and spark their curiosity.`,
        },
      ],
    },

    classes: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      length: 3,
    }
  },

  computed: {
    itemsDisplayed() {
      return this.items.slice(0, this.length)
    },
  },

  methods: {
    loadMore() {
      if (this.length > this.items.length) {
        return
      } else {
        this.length += 3
      }
    },
  },
}
</script>

<style scoped>
h3,
h4 {
  font-family: Montserrat;
}
h3 {
  font-size: 2rem;
  font-weight: 700;
}
h4 {
  font-size: 1.25rem;
  font-weight: 700;
}
.black-bottom-overlay {
  border-image: linear-gradient(
      180deg,
      hsla(0, 0%, 0%, 0),
      hsla(0, 0%, 0%, 0.2),
      hsla(0, 0%, 0%, 0.8)
    )
    fill 1;
}

.list-enter-active {
  animation: fade-in 0.5s ease-in-out;
}

.list-leave-active {
  animation: fade-in 0.5s ease-in-out reverse;
}

@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translateY(30px);
  }

  100% {
    transform: translateY(0px);
  }
}
</style>
